module.exports = __webpack_public_path__ + "img/Frame 2136.93c0e39e.png";